import { BusinessType } from '../../../constants/business-type';
import { MigrationStatus } from '../../../constants/migration-status';
import { Deserializable } from '../../deserializable';
import { BusinessDTO } from '../../requests/business-dto/business-dto';
import { BusinessLevel } from '../business-level/business-level';
import { Country } from '../country/country';

/**
 * Model of Business from responses
 */
export class BusinessResponseDTO extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public businessName?: string,
    public businessType?: BusinessType,
    public email?: string,
    public website?: string,
    public imgSource?: string,
    public address?: string,
    public addressNumber?: string,
    public postalCode?: string,
    public country?: Country,
    public state?: string,
    public businessLevel?: BusinessLevel,
    public businessLevels?: BusinessLevel[],
    public id?: number,
    public active?: boolean,
    public phoneNumber?: string,
    public newBusiness?: boolean,
    public migrationStatus?: MigrationStatus,
    public registerDate?: Date
  ) {
    super();
  }

  /**
   *  Converts BusinessResponseDTO to BusinessDTO
   *  This conversion is not bidirectional
   * @return {BusinessDTO}
   */
  toBusinessDto() {
    return new BusinessDTO(
      this.businessName!,
      this.businessType!,
      this.businessLevel!.id,
      this.businessLevels!,
      this.email!,
      this.website!,
      this.imgSource!,
      this.address!,
      this.addressNumber!,
      this.postalCode!,
      this.country!.id,
      this.state!,
      this.id!,
      this.active!,
      this.phoneNumber!
    );
  }

  /**
   * @param {BusinessDTO} business
   */
  update(business: BusinessDTO) {
    this.businessName = business.businessName;
    this.businessType = business.businessType;
    this.email = business.email;
    this.website = business.website;
    this.imgSource = business.imgSource;
    this.address = business.address;
    this.addressNumber = business.addressNumber;
    this.postalCode = business.postalCode;
    this.state = business.state;
  }
}
